import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { BottomsheetShared } from '../../general/shared/bottomsheet-shared';
import { WeightLogService } from 'src/app/data/repository/plan-repository/weight-log.service';
import { Weightlog } from 'src/app/core/model/api-response/weight-log-response-model';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { WeightLogDataService } from 'src/app/data/repository/plan-repository/weight-log-data.service';

@Component({
  selector: 'app-plan-weight',
  templateUrl: './plan-weight.component.html',
  styleUrls: ['./plan-weight.component.scss'],
})
export class PlanWeightComponent implements OnInit, OnDestroy {
  _date: Date = new Date(new Date().setHours(0, 0, 0, 1));

  @Input() set categoryId(value: Date) {
    this._date = value;
    this.getWeight();
  }
  private _weightDataIsReady = false;
  @Input() set weightDataIsReady(value: boolean) {
    this._weightDataIsReady = value;
    if (value) {
      this.getWeight();
    } else {
      this.dataIsReady = false;
    }
  }
  get weightDataIsReady(): boolean {
    return this._weightDataIsReady;
  }

  weightlog: Weightlog;
  dataIsReady = false;

  subscription1: Subscription;

  constructor(
    private bottomsheetShared: BottomsheetShared,
    private weightLogService: WeightLogService,
    private snackBarService: SnackBarService
  ) {
    this.subscription1 =
      this.bottomsheetShared.closeAndUpdateBottomsheetObs$.subscribe(
        (close) => {
          if (close) {
            this.getWeight();
          }
        }
      );
  }

  ngOnInit() {}

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
  }

  async getWeight() {
    const weight = await this.weightLogService.getLastWeight(this._date);
    if (weight) {
      this.weightlog = weight;
      this.dataIsReady = true;
    } else {
      this.dataIsReady = true;
      this.weightlog = new Weightlog(
        89,
        new Date(new Date().setHours(0, 0, 0, 1)).getTime(),
        '-'
      );
    }
  }

  openBottomsheet() {
    this.bottomsheetShared.selectedDate = this._date;
    this.bottomsheetShared.selectedWeightlog = this.weightlog;
    this.bottomsheetShared.bottomsheetType = 'weightLog';
    this.bottomsheetShared.openBottomsheet();
  }
}
